import { useState, useEffect, useContext } from "react";
import { useLocation } from "react-router-dom";
import { customerContext } from "../context/contexts";
import { Box, MenuItem, InputAdornment } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { getobj, postobj, updateobj } from "../apicall/apicall";
import Switch from "@mui/material/Switch";
import EditIcon from "@mui/icons-material/Edit";
import { max_width, logoStyle, lebelStyle, textfield } from "../style/style";
import { test_data } from "../apicall/testdata";
import { NotificationManager } from "react-notifications";
import NotificationContainer from "react-notifications/lib/NotificationContainer";
import Cookies from "js-cookie";
import { validated } from "../apicall/validateform";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { customer, profile } from "../apicall/constants";
import { validateForms } from "../apicall/commonFunction";
const urlRegex =
  /^(https?|ftp):\/\/([A-Za-z0-9.-]+)(:\d+)?(\/[^/]*)*?$|^\s*$|^NA$/;

export default function Profile(props) {
  const [refreshed, setrefresh] = useState(false);
  const [checked, setcheck] = useState();
  const [basic, setbasic] = useState();
  const [open, setopen] = useState({ name: "", value: false });
  const [urldata, seturl] = useState({});
  const [loaded, setloaded] = useState(true);
  const [hide, sethide] = useState(false);
  const [test, settest] = useState(false);
  const [test_device, settestdevice] = useState();
  const [editProfile, seteditProfile] = useState(false);
  const [newVal, setnewVal] = useState({ id: props.id });
  const [api_key, setapikey] = useState();
  const [customerinfo, setcustomerinfo] = useState(false);
  const [updateemailDialogue, setupdateemaildialogue] = useState(false);
  const [otpSent, setOtpSent] = useState(false);
  const [otp, setotp] = useState();
  const [distributor, setdistributor] = useState("");
  const [changePassword, setChangePassword] = useState(false);
  const [errors, setErrors] = useState({});
  const [show, setShow] = useState(false);
  const customerContest = useContext(customerContext);
  const { manage } = useContext(customerContext);

  const loc = useLocation();
  useEffect(() => {
    const url =
      process.env.REACT_APP_ZEWA_URL + "user/get-customer/" + props.id + "/";
    const d = getobj(url);
    d.then(function (res) {
      setbasic(res.data);
      setapikey(res.token);
      setcheck(res.data.data_forwarding_status);
      setloaded(false);
      setdistributor(
        res.distributor !== "NA" ? res.distributor.company_name : "NA",
      );
    });
  }, [refreshed, props.id]);

  const handleNewChange = (e) => {
    const { name, value } = e.target;
    setnewVal({
      ...newVal,
      [name]: value,
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    // console.log(e.target.name);
    if (
      loc.pathname === "/admin" ||
      loc.pathname === "/distributor" ||
      loc.pathname === "/distributor-user"
    ) {
      if (name === "status") {
        setcheck(e.target.checked);

        updateProfile({
          id: props.id,
          data_forwarding_status: e.target.checked,
        });
      } else if (
        basic &&
        (name === "data_forwarding_url" || name === "token")
      ) {
        let data = {
          token: basic.token,
          data_forwarding_url: basic.data_forwarding_url,
        };
        seturl({ ...data, ...urldata, id: props.id, [name]: value });
      } else if (name === "logo") {
        if (
          [
            "jpeg",
            "png",
            "jpg",
            "gif",
            "apng",
            "svg",
            "bmp",
            "bmp ico",
            "png ico",
          ].includes(e.target.files[0].name.split(".")[1])
        ) {
          seturl({ id: props.id, logo: e.target.files[0] });
        } else {
          NotificationManager.remove(NotificationManager.listNotify[0]);

          NotificationManager.error("Invalid file format", "Wrong format", 200);
        }
      }
    } else if (loc.pathname === "/customer") {
      if (name === "status") {
        setcheck(e.target.checked);
        updateProfile({ data_forwarding_status: e.target.checked });
      } else if (name === "data_forwarding_url" || name === "token") {
        seturl({ ...urldata, [name]: value });
      } else if (name === "logo") {
        if (
          [
            "jpeg",
            "png",
            "jpg",
            "gif",
            "apng",
            "svg",
            "bmp",
            "bmp ico",
            "png ico",
          ].includes(e.target.files[0].name.split(".")[1])
        ) {
          seturl({ logo: e.target.files[0] });
        } else {
          NotificationManager.remove(NotificationManager.listNotify[0]);

          NotificationManager.error("Invalid file format", "Wrong format", 200);
        }
      }
    }
  };

  const handleClose = () => {
    setopen({
      name: "",
      value: false,
    });
    seturl({});
    setErrors({});
  };
  const uploadlogo = async (data) => {
    const url = process.env.REACT_APP_ZEWA_URL + "user/customer-profile/";
    const uploadData = new FormData();
    uploadData.append("id", props.id);
    uploadData.append("logo", data.logo);
    await fetch(url, {
      headers: {
        Authorization: "Token " + sessionStorage.getItem("token"),
        "X-CSRFToken": Cookies.get("csrftoken"),
      },
      method: "PATCH",
      body: uploadData,
    })
      .then((res) => {
        console.log(res);
        setopen(false);
        NotificationManager.remove(NotificationManager.listNotify[0]);

        NotificationManager.success("Updated Successfully");
        setrefresh(!refreshed);
        if (loc.pathname === "/customer") {
          customerContest.setmanage({
            ...manage,
            refresh: !manage.refresh,
          });
        }
      })
      .catch((err) => {
        NotificationManager.error(err.Message);
      });
  };
  const updateProfile = (data) => {
    console.log(data, "in update profile");
    const val = validateForms(data, customer);
    if (val.success) {
      if (validated(data)) {
        const url = process.env.REACT_APP_ZEWA_URL + "user/customer-profile/";
        const res = updateobj(url, data);
        res
          .then((response) => {
            console.log(response);
            if (response.status === 200) {
              return response;
            }
            throw new Error(response);
          })
          .then(function (res) {
            setopen({
              name: "",
              value: false,
            });
            setrefresh(!refreshed);
            setnewVal({ id: props.id });
            NotificationManager.remove(NotificationManager.listNotify[0]);
            seteditProfile(false);

            NotificationManager.success(res.Message);
          })
          .catch((err) => {
            console.log(err);
            setnewVal({ id: props.id });
            NotificationManager.remove(NotificationManager.listNotify[0]);
            seteditProfile(false);
            NotificationManager.error(err.Message);
          });
      } else {
        setnewVal({ id: props.id });
        seteditProfile(false);

        NotificationManager.remove(NotificationManager.listNotify[0]);

        NotificationManager.error("No fields can be left blank");
      }
    } else {
      setErrors(val.data);
      return;
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!urlRegex.test(urldata.data_forwarding_url)) {
      newErrors.data_forwarding_url = "Please provide valid URL";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return false;
    }
    return true;
  };

  const updateDataForwardingUrl = (data) => {
    if (validateForm()) {
      const url = process.env.REACT_APP_ZEWA_URL + "user/customer-profile/";
      const res = updateobj(url, {
        ...data,
        data_forwarding_url: data.data_forwarding_url || "NA",
      });
      res
        .then((response) => {
          console.log(response);
          if (response.status === 200) {
            return response;
          }
          throw new Error(response);
        })
        .then(function (res) {
          setopen({
            name: "",
            value: false,
          });
          setrefresh(!refreshed);
          setnewVal({ id: props.id });
          setErrors({});
          NotificationManager.remove(NotificationManager.listNotify[0]);

          NotificationManager.success(res.Message);
        })
        .catch((err) => {
          console.log(err);
          setnewVal({ id: props.id });
          NotificationManager.remove(NotificationManager.listNotify[0]);

          NotificationManager.error(err.Message);
        });
    }
  };

  const handletestforwarding = async (data) => {
    const url = basic.data_forwarding_url;
    const local_url = process.env.REACT_APP_ZEWA_URL + "device/send-test-data/";
    let payload = {};
    payload["data"] = test_data[test_device];
    payload["dfu"] = url;
    payload["token"] = basic.token;

    console.log(data);
    if (url !== "") {
      let res = postobj(local_url, payload);

      res.then(function (res) {
        if (res.status >= 400) {
          NotificationManager.remove(NotificationManager.listNotify[0]);

          NotificationManager.error(res.statusText, "Failed", 2000);
        } else {
          NotificationManager.remove(NotificationManager.listNotify[0]);

          NotificationManager.success("Data Sent", "Sent", 2000);
          settest(false);
          // console.log(res);
        }
      });
    }
  };

  const updateCustomerInfo = () => {
    const val = validateForms(newVal, profile);
    if (val.success) {
      const url =
        process.env.REACT_APP_ZEWA_URL + "user/update/" + newVal["id"] + "/";
      updateobj(url, newVal)
        .then(function (res) {
          if (res.status === 200) {
            setrefresh(!refreshed);
            NotificationManager.remove(NotificationManager.listNotify[0]);

            NotificationManager.success(res.message);
            setcustomerinfo(false);
          } else {
            NotificationManager.remove(NotificationManager.listNotify[0]);

            NotificationManager.error(res.message);
            setcustomerinfo(false);
          }
        })
        .catch((err) => {
          NotificationManager.remove(NotificationManager.listNotify[0]);

          NotificationManager.error(err.message);
          setcustomerinfo(false);
        });
    } else {
      setErrors(val.data);
      return;
    }
  };

  const handleChangePassword = (e) => {
    e.preventDefault();
    setnewVal({ id: props.id });
    const url = process.env.REACT_APP_ZEWA_URL + "user/update-password/";
    if (validated(newVal)) {
      const res = updateobj(url, newVal);
      res
        .then((res) => {
          console.log(res);
          setChangePassword(false);
          NotificationManager.remove(NotificationManager.listNotify[0]);

          NotificationManager.success("Updated Successfully");
          setrefresh(!refreshed);
        })
        .catch((err) => {
          NotificationManager.remove(NotificationManager.listNotify[0]);

          NotificationManager.error(err.Message);
        });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const actionFunction =
      open.name === "dfu" ? updateDataForwardingUrl : uploadlogo;
    actionFunction(urldata);
  };

  return (
    <div>
      {loaded ? (
        <img
          src="https://zewa-logo-bucket.s3.amazonaws.com/logo/Spinner-1s-200px.gif"
          alt="loading..."
        />
      ) : (
        <Box>
          {basic && (
            <TableContainer>
              <Table
                sx={{ minWidth: 650 }}
                size="small"
                aria-label="a dense table"
              >
                <TableBody>
                  <TableRow>
                    <TableCell> Company Name:</TableCell>{" "}
                    <TableCell>{basic.company_name}</TableCell>
                    <TableCell>
                      <Button
                        onClick={() => {
                          seteditProfile(true);
                          setErrors({});
                        }}
                        startIcon={<EditIcon color="primary" />}
                      ></Button>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell> Name</TableCell>
                    <TableCell>
                      {basic.customer_first_name +
                        " " +
                        basic.customer_last_name}
                    </TableCell>
                    <TableCell>
                      <Button
                        onClick={() => {
                          setcustomerinfo(true);
                          setErrors({});
                        }}
                        startIcon={<EditIcon color="primary" />}
                      ></Button>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell> API Key</TableCell>
                    <TableCell>{api_key && api_key}</TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell> Email</TableCell>
                    <TableCell>{basic.customer_email}</TableCell>
                    <TableCell>
                      <Button
                        onClick={() => setupdateemaildialogue(true)}
                        startIcon={<EditIcon color="primary" />}
                      ></Button>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell> Phone:</TableCell>
                    <TableCell>{basic.customer_phone_number}</TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell> Company Address:</TableCell>
                    <TableCell>{basic.company_address}</TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell> City:</TableCell>
                    <TableCell>{basic.city}</TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell> State:</TableCell>
                    <TableCell>{basic.state}</TableCell>
                    <TableCell></TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell> Zip Code:</TableCell>{" "}
                    <TableCell>{basic.zip_code}</TableCell>
                    <TableCell></TableCell>
                  </TableRow>

                  {loc.pathname === "/admin" && (
                    <TableRow>
                      <TableCell> Change Password:</TableCell>{" "}
                      <TableCell></TableCell>
                      <TableCell>
                        <Button onClick={() => setChangePassword(true)}>
                          Change
                        </Button>
                      </TableCell>
                    </TableRow>
                  )}
                  <TableRow>
                    <TableCell> Distributor:</TableCell>{" "}
                    <TableCell>{distributor}</TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell> Data Forwarding Url:</TableCell>{" "}
                    <TableCell>{basic.data_forwarding_url}</TableCell>
                    <TableCell>
                      {(loc.pathname === "/admin" ||
                        loc.pathname === "/distributor" ||
                        loc.pathname === "/distributor-user") && (
                        <>
                          <Button
                            onClick={() => {
                              setopen({
                                name: "dfu",
                                value: true,
                              });
                              seturl({
                                data_forwarding_url: basic.data_forwarding_url,
                                token: basic.token || "",
                                id: props.id,
                              });
                            }}
                          >
                            Update
                          </Button>
                          <Button onClick={() => settest(!test)}>Test</Button>
                        </>
                      )}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell> Data Forwarding Status:</TableCell>{" "}
                    <TableCell>
                      {basic.data_forwarding_status === false ? "OFF" : "ON"}
                    </TableCell>
                    <TableCell>
                      {(loc.pathname === "/admin" ||
                        loc.pathname === "/distributor" ||
                        loc.pathname === "/distributor-user") && (
                        <Switch
                          checked={checked}
                          onChange={handleChange}
                          name="status"
                          inputProps={{ "aria-label": "controlled" }}
                        />
                      )}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell> Logo:</TableCell>{" "}
                    <TableCell>
                      <img src={basic.logo} style={logoStyle} alt="logo" />
                      {/* "http://127.0.0.1:8000" + */}
                    </TableCell>
                    <TableCell>
                      <Button
                        onClick={() => {
                          setopen({
                            name: "logo",
                            value: true,
                          });
                        }}
                      >
                        Change
                      </Button>
                    </TableCell>
                  </TableRow>
                  {(loc.pathname === "/admin" ||
                    loc.pathname === "/distributor" ||
                    loc.pathname === "/distributor-user") && (
                    <TableRow>
                      <TableCell>Token</TableCell>
                      <TableCell>
                        <p type="password">
                          {hide
                            ? basic.token
                            : basic.token
                              ? "****************"
                              : "No Token Added"}
                        </p>
                      </TableCell>
                      <TableCell>
                        <Button
                          onClick={() => {
                            sethide(!hide);
                          }}
                        >
                          {hide ? "hide" : "show"}
                        </Button>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </Box>
      )}
      <NotificationContainer />
      <Dialog open={open.value} onClose={handleClose} maxWidth={max_width}>
        <DialogTitle>
          {open.name === "dfu" ? "Enter data forwarding URL:" : "Upload Logo:"}
        </DialogTitle>
        <form onSubmit={handleSubmit}>
          <DialogContent>
            {open.name === "dfu" ? (
              <div>
                <TextField
                  error={errors.data_forwarding_url || false}
                  autoFocus
                  margin="dense"
                  id="name"
                  name="data_forwarding_url"
                  label="Enter Data Forwarding URL"
                  defaultValue={basic ? basic.data_forwarding_url : ""}
                  type="text"
                  fullWidth
                  variant="standard"
                  onChange={(e) => {
                    handleChange(e);
                  }}
                  helperText={
                    errors.data_forwarding_url ? errors.data_forwarding_url : ""
                  }
                />
                <TextField
                  autoFocus
                  margin="dense"
                  id="name"
                  name="token"
                  label="Enter Authorization Token"
                  defaultValue={basic ? basic.token : ""}
                  type="text"
                  fullWidth
                  variant="standard"
                  onChange={(e) => {
                    handleChange(e);
                  }}
                />
              </div>
            ) : (
              <div>
                <input
                  type="file"
                  name="logo"
                  onChange={(e) => {
                    handleChange(e);
                  }}
                />
                <p style={lebelStyle}>
                  logo size should be 90 * 100 pixels
                  <br /> Accepted formats: jpeg, gif, png, apng, svg, bmp, bmp
                  ico, png ico.
                </p>
              </div>
            )}
          </DialogContent>
          <DialogActions>
            <Button
              variant="contained"
              color="error"
              onClick={(e) => {
                handleClose(e);
              }}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              // onClick={() => {
              //   open.name == "dfu" ? updateDataForwardingUrl(urldata) : uploadlogo(urldata);
              // }}
            >
              {open.name === "dfu" ? "Update" : "Upload"}
            </Button>
          </DialogActions>
        </form>
      </Dialog>
      <Dialog open={test} onClose={() => settest(false)}>
        <DialogTitle>Test Data forwarding</DialogTitle>

        <TextField
          select
          label="Select Device"
          name="device_group"
          id="deviceName"
          sx={{ width: "400px", margin: "5px" }}
          variant="outlined"
          value={test_device}
          onChange={(e) => {
            settestdevice(e.target.value);
          }}
        >
          {Object.keys(test_data).map((i) => {
            return (
              <MenuItem value={i} key={i}>
                {i}
              </MenuItem>
            );
          })}
        </TextField>
        <DialogActions>
          <Button
            variant="contained"
            color="error"
            onClick={() => {
              settest(false);
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              // console.log("clicked");
              handletestforwarding(basic);
            }}
          >
            Send
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={editProfile} onClose={() => seteditProfile(false)}>
        <DialogTitle>Update Profile</DialogTitle>

        <TextField
          id="outlined-basic"
          name="company_name"
          label="Enter Comapny Name"
          defaultValue={basic && basic.company_name}
          variant="outlined"
          sx={textfield}
          onChange={handleNewChange}
          helperText={errors.company_name ? errors.company_name : ""}
          error={errors.company_name || false}
        />
        <TextField
          id="outlined-basic"
          label="Enter Company Address"
          defaultValue={basic && basic.company_address}
          name="company_address"
          variant="outlined"
          sx={textfield}
          onChange={handleNewChange}
          helperText={errors.company_address ? errors.company_address : ""}
          error={errors.company_address || false}
        />
        <TextField
          id="outlined-basic"
          label="Enter City"
          defaultValue={basic && basic.city}
          name="city"
          variant="outlined"
          sx={textfield}
          onChange={handleNewChange}
          helperText={errors.city ? errors.city : ""}
          error={errors.city || false}
        />
        <TextField
          id="outlined-basic"
          label="Enter State"
          defaultValue={basic && basic.state}
          name="state"
          sx={textfield}
          variant="outlined"
          onChange={handleNewChange}
          helperText={errors.state ? errors.state : ""}
          error={errors.state || false}
        />
        <TextField
          id="outlined-basic"
          label="Enter Zip Code"
          defaultValue={basic && basic.zip_code}
          name="zip_code"
          variant="outlined"
          sx={textfield}
          onChange={handleNewChange}
          helperText={errors.zip_code ? errors.zip_code : ""}
          error={errors.zip_code || false}
        />

        <DialogActions>
          <Button
            variant="contained"
            color="error"
            onClick={() => {
              setnewVal({ id: props.id });

              seteditProfile(false);
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              //console.log("clicked");
              updateProfile(newVal);
            }}
          >
            Update
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={customerinfo} onClose={() => setcustomerinfo(false)}>
        <DialogTitle>Update Profile</DialogTitle>

        <TextField
          id="outlined-basic"
          name="first_name"
          label="Enter First Name"
          defaultValue={basic && basic.customer_first_name}
          variant="outlined"
          helperText={errors.first_name ? errors.first_name : ""}
          error={errors.first_name || false}
          sx={textfield}
          onChange={handleNewChange}
        />
        <TextField
          id="outlined-basic"
          label="Enter Last Name"
          defaultValue={basic && basic.customer_last_name}
          helperText={errors.last_name ? errors.last_name : ""}
          error={errors.last_name || false}
          name="last_name"
          variant="outlined"
          sx={textfield}
          onChange={handleNewChange}
        />
        <TextField
          id="outlined-basic"
          label="Enter Phone Number"
          defaultValue={basic && basic.customer_phone_number}
          name="phone_number"
          helperText={errors.phone_number ? errors.phone_number : ""}
          error={errors.phone_number || false}
          variant="outlined"
          sx={textfield}
          onChange={handleNewChange}
        />

        <DialogActions>
          <Button
            variant="contained"
            color="error"
            onClick={() => {
              setnewVal({ id: props.id });
              setcustomerinfo(false);
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              // console.log("clicked");
              updateCustomerInfo(newVal);
            }}
          >
            Update
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={updateemailDialogue}
        onClose={() => {
          setOtpSent(false);
          setupdateemaildialogue(false);
        }}
      >
        <DialogTitle>Update Profile</DialogTitle>

        <TextField
          id="outlined-basic"
          name="email"
          label="Enter Email"
          defaultValue={basic && basic.customer_email}
          variant="outlined"
          sx={textfield}
          onChange={handleNewChange}
        />
        {otpSent && (
          <TextField
            id="outlined-basic"
            name="email"
            label="Enter OTP"
            variant="outlined"
            sx={textfield}
            onChange={(e) => {
              setotp(e.target.value);
            }}
          />
        )}

        <DialogActions>
          <Button
            variant="contained"
            color="error"
            onClick={() => {
              setupdateemaildialogue(false);
              setotp(null);
              setnewVal({ id: props.id });
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              if (otpSent) {
                //console.log(newVal);
                const url =
                  process.env.REACT_APP_ZEWA_URL +
                  "user/update/" +
                  newVal["id"] +
                  "/?email=true&otp=true";
                const payload = {
                  ...newVal,
                  otp: otp,
                };
                const res = updateobj(url, payload)
                  .then(function (res) {
                    // console.log(res);
                    if (res.status === 200) {
                      setotp();
                      setOtpSent(false);
                      NotificationManager.success(res.message);
                      setrefresh(!refreshed);
                      setupdateemaildialogue(false);
                    } else {
                      setotp();
                      NotificationManager.error(res.message);
                    }
                  })
                  .catch((err) => {
                    NotificationManager.error(res.message, "Failed", 2000);
                  });
              } else {
                const url =
                  process.env.REACT_APP_ZEWA_URL +
                  "user/update/" +
                  newVal["id"] +
                  "/?email=true";
                // console.log(newVal);
                updateobj(url, newVal)
                  .then(function (res) {
                    if (res.status === 200) {
                      NotificationManager.success(res.message, "Success", 2000);
                      setOtpSent(true);
                      setotp();
                    } else {
                      NotificationManager.error(res.message, "Failed", 2000);
                    }
                  })
                  .catch((err) => {
                    NotificationManager.error(err.message, "Failed", 2000);
                  });
              }
            }}
          >
            {otpSent ? "verify" : "Update"}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={changePassword} onClose={() => setChangePassword(false)}>
        <DialogTitle>Change Password</DialogTitle>
        <form onSubmit={handleChangePassword}>
          <TextField
            id="outlined-basic"
            name="new_password"
            sx={textfield}
            type={show ? "text" : "password"}
            label="Enter Password"
            variant="outlined"
            onChange={handleNewChange}
            required
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  {show ? (
                    <VisibilityOff
                      onClick={() => {
                        setShow(false);
                      }}
                    />
                  ) : (
                    <Visibility
                      onClick={() => {
                        setShow(true);
                      }}
                    />
                  )}
                </InputAdornment>
              ),
            }}
          />

          <DialogActions>
            <Button
              variant="contained"
              color="error"
              onClick={() => setChangePassword(false)}
            >
              Cancel
            </Button>
            <Button type="submit" variant="contained" color="primary">
              Update
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </div>
  );
}
